import gql from 'graphql-tag';

import { EVENT_FRAGMENT } from '../../fragments/event.fragment';

export const COMPLETE_EVENT_ACTIVITIES = gql`
  mutation CompleteEventActivities($input: CompleteEventActivitiesInput!) {
    dealActivity {
      result: completeEventActivities(input: $input) {
        error
        success
        list {
          __typename
          ...EventFields
        }
      }
    }
  }
  ${EVENT_FRAGMENT}
`;
